/* Native "buy more, save more" volume bundle block.
   Selecting a tier just updates the theme's own quantity input and fires
   its native "change" event, so the theme's existing quantity/subtotal/
   sticky-add-to-cart logic (see QuantityInput in variants.js) does the rest.
   No network request is made by this widget. */
(function () {
    function getQuantityInput(productId) {
        return (
            document.getElementById('quantity-' + productId) ||
            document.querySelector('.quantity__group--1 .quantity__input')
        );
    }

    function getFormsForProduct(productId) {
        // Some templates render more than one add-to-cart form for the same
        // product (main form, sticky-bar form, installment form, etc). Every
        // one of them needs the same quantity, or whichever button the
        // shopper actually clicks can silently submit the old value.
        return Array.prototype.filter.call(
            document.querySelectorAll('form[action="/cart/add"]'),
            function (form) {
                var id = form.getAttribute('id') || '';
                return id.indexOf('-' + productId) !== -1;
            }
        );
    }

    function applyQuantity(productId, value) {
        // If the theme has a visible quantity stepper on this page, update it
        // too and let its own subtotal/sticky-cart logic react to "change".
        var qtyInput = getQuantityInput(productId);
        if (qtyInput && qtyInput.value !== String(value)) {
            qtyInput.value = value;
           
        }

        // Whatever the theme does or doesn't render, every add-to-cart form
        // for this product needs its own quantity field set. Some of this
        // theme's forms don't include one at all (Shopify then silently
        // defaults to 1), so create it when it's missing rather than assume
        // it exists.
        getFormsForProduct(productId).forEach(function (form) {
            var formQty = form.querySelector('input[name="quantity"]');
            if (!formQty) {
                formQty = document.createElement('input');
                formQty.type = 'hidden';
                formQty.name = 'quantity';
                form.appendChild(formQty);
            }
            formQty.value = value;
        });
    }

    function initVolumeBundle(root) {
        if (!root || root.getAttribute('data-vb-init') === 'true') return;
        root.setAttribute('data-vb-init', 'true');

        var productId = root.getAttribute('data-product-id');
        var radios = root.querySelectorAll('[data-volume-bundle-radio]');

        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                if (radio.checked) applyQuantity(productId, radio.value);
            });
        });

        // Safety net: re-apply whichever tier is currently checked right
        // before any of this product's add-to-cart forms actually submits.
        // Some themes reset/re-render the form after a previous add (e.g.
        // once the cart drawer opens and closes), which can silently drop
        // the quantity we set earlier back to 1 even though the radio
        // itself is still visibly selected. Using capture:true makes this
        // run before the theme's own submit handling reads the form data.
        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form || form.tagName !== 'FORM') return;
            var id = form.getAttribute('id') || '';
            if (id.indexOf('-' + productId) === -1) return;
            var checked = root.querySelector('[data-volume-bundle-radio]:checked');
            if (checked) applyQuantity(productId, checked.value);
        }, true);
    }

    function initAll(scope) {
        (scope || document).querySelectorAll('[data-volume-bundle]').forEach(initVolumeBundle);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }

    // Re-init after theme editor section re-renders.
    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();